( function() {
    "use strict";

    angular
        .module("ccsTrApp")
        .controller("LotSearchDialogController", LotSearchDialogController);

    LotSearchDialogController.$inject = ['$scope', '$q', '$uibModalInstance', 'LotCustomService', 'LotSearchGridDTO', 'ContractCustomService', 'ShipmentCustomService', 'ToastrService', 'siEntity',
        'contractEntity', 'contractEntityB', 'contractEntityC', 'contractEntityD', 'contractEntityE', 'contractEntityF', 'saleContractEntity', '$uibModal', 'Lot', 'allocatedLots'];

    function LotSearchDialogController($scope, $q, $uibModalInstance, LotCustomService, LotSearchGridDTO, ContractCustomService, ShipmentCustomService, ToastrService, siEntity,
                                       contractEntity, contractEntityB, contractEntityC, contractEntityD, contractEntityE, contractEntityF, saleContractEntity, $uibModal, Lot, allocatedLots) {

        var vm = this;

        vm.allocateSelected = allocateSelected;
        vm.cancel = cancel;
        vm.refresh = refresh;
        vm.split = split;
        vm.fetchLots = fetchLots;
        vm.initFilter = initFilter;
        vm.reset = reset;
        vm.cleanFilter = cleanFilter;
        vm.getPurchContracts = getPurchContracts;
        vm.processAllocatedLots = processAllocatedLots;
        vm.page = 0;
        vm.lots = [];
        vm.selectedLots = [];
        vm.purchaseContracts = [];
        vm.purchIds = [];
        vm.si = null;
        vm.saleContract = saleContractEntity;
        vm.predicate = 'id';
        vm.direction = 'asc';
        vm.filterModel = {
            lotRef: '',
            cropYear: '',
            qtyBalesFrom: null,
            qtyBalesFTo: null,
            purchaseContractId: 0,
            purchaseContractsId: [],
            allocatedLotsId: [],
            loadingPlace: ''
        };
        vm.allocatedLots = allocatedLots;
        vm.allocatedLotsIds = [];

        vm.gridOptions = {
            paginationPageSizes: [10, 25, 50, 75, 100],
            paginationPageSize: 100,
            enableFiltering: false,
            enableGridMenu: false,
            enableRowSelection: true,
            enableSelectAll: true,
            showGridFooter: true,
            useExternalPagination: true,
            onRegisterApi: function( gridApi ) {
                gridApi.pagination.getLastRowIndex = function () {
                    return vm.gridOptions.totalItems - 1;
                };
                $scope.gridApi = gridApi;
            },
            columnDefs: [
                {name: 'P.Contract', field: 'contractNum', width: 100, visible: true},
                {name: 'Lot', field: 'lotRef', width: 100, visible: true},
                {name: 'Crop Year', field: 'cropYear', width: 90, visible: true},
                {name: 'Type', field: 'lotType', width: 90, visible: true},
                {name: 'Qty Bales', field: 'qtyBales', width: 90, visible: true},
                {name: 'Mic', field: 'lotMic', width: 90, visible: true},
                {name: 'Len', field: 'lotLen', width: 90, visible: true},
                {name: 'Str', field: 'lotStr', width: 90, visible: true},
                {name: 'RD+B', field: 'lotRdb', width: 100, visible: true},
                {name: 'S.F.I.', field: 'lotSfi', width: 90, visible: true}
            ]
        };

        processAllocatedLots();
        checkPurchContracts();
        fetchLots();

        if (siEntity.id !== null) {
            vm.si = siEntity;
        }

        function processAllocatedLots() {
            vm.allocatedLotsIds = [];
            if (vm.allocatedLots) {
                for (var i = 0; i < vm.allocatedLots.length; i++) {
                    vm.allocatedLotsIds.push(vm.allocatedLots[i].id);
                }
            }
        }

        function initFilter() {
            vm.filterModel = {
                lotRef: '',
                cropYear: '',
                qtyBalesFrom: null,
                qtyBalesFTo: null,
                purchaseContractId: 0,
                purchaseContractsId: [],
                allocatedLotsId: [],
                loadingPlace: ''
            };
        }

        function cleanFilter() {
            vm.initFilter();
            vm.reset();
        }

        function reset() {
            vm.page = 0;
            vm.lots = [];
            vm.fetchLots()
        }

        function checkPurchContracts() {
            vm.purchIds.length = 0;
            if (contractEntity) {
                vm.purchIds.push(contractEntity.id);
            }
            if (contractEntityB) {
                vm.purchIds.push(contractEntityB.id);
            }
            if (contractEntityC) {
                vm.purchIds.push(contractEntityC.id);
            }
            if(contractEntityD) {
                vm.purchIds.push(contractEntityD.id);
            }
            if(contractEntityE) {
                vm.purchIds.push(contractEntityE.id);
            }
            if(contractEntityF) {
                vm.purchIds.push(contractEntityF.id);
            }
        }

        function getPurchContracts() {
            var contracts = [];
            if (contractEntity) {
                contracts.push(contractEntity);
            }
            if (contractEntityB) {
                contracts.push(contractEntityB);
            }
            if (contractEntityC) {
                contracts.push(contractEntityC);
            }
            if(contractEntityD) {
                contracts.push(contractEntityD);
            }
            if(contractEntityE) {
                contracts.push(contractEntityE);
            }
            if(contractEntityF) {
                contracts.push(contractEntityF);
            }
            return contracts;
        }

        function allocateSelected() {
            vm.selectedLots.length = 0;
            var defer = $q.defer();
            var promlist = [];
            angular.forEach($scope.gridApi.selection.getSelectedRows(), function (value, key) {
                var index = vm.lots.indexOf(value);
                promlist.push(
                    LotCustomService.returnMinifiedLot(vm.lots[index].id).then(function(data) {
                        var curLot = data.data;
                        curLot.allocSale = vm.saleContract;
                        curLot.purchSi = vm.si;
                        curLot.allocSi = vm.si;
                        if(curLot.lotStatus === "AVAILABLE") curLot.lotStatus = "ALLOCATED";
                        vm.selectedLots.push(curLot);
                    })
                );
            });
            $q.all(promlist).then(function() {
                if (null !== vm.si) {
                    LotCustomService.allocateLotsToShipment(vm.selectedLots).then(function (response) {
                        ToastrService.success("Successfully Allocated Lots", "Success!");
                        defer.resolve();
                        $uibModalInstance.close(vm.selectedLots);
                    }, function (error) {
                        ToastrService.error(error.details, "Error!");
                    });
                } else {
                    defer.resolve();
                    $uibModalInstance.close(vm.selectedLots);
                }
            });

            return defer;
        }

        function fetchLots() {
            vm.purchaseContracts = getPurchContracts();
            vm.lots = [];
            vm.filterModel.purchaseContractsId = vm.purchIds;
            vm.filterModel.allocatedLotsId = vm.allocatedLotsIds;

            if(vm.gridOptions) {
                vm.gridOptions.data = [];
            }

            var queryParams = {
                page: vm.page,
                size: vm.gridOptions.paginationPageSize,
                sort: vm.direction
            };
            queryParams = Object.assign({}, queryParams, vm.filterModel);
            LotSearchGridDTO.query(queryParams, onSuccess, onError);

            function onSuccess(data, headers) {
                var skipped = 0;
                vm.lots = angular.copy(data);
                vm.gridOptions.data = vm.lots;
                vm.gridOptions.totalItems = headers('X-Total-Count') * 1.0 - skipped;
                $scope.gridApi.selection.clearSelectedRows();
            }

            function onError(error) {
                if(error.status !== "404") {
                    ToastrService.error("Failed to get AVAILABLE Lots", "Error!");
                    console.log(JSON.stringify(error));
                } else {
                    ToastrService.info("No AVAILABLE Lots", "Info");
                }
            }
        }

        function refresh() {
            fetchLots();
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function split() {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/lot/modal/lot-split-modal.html',
                controller: 'LotSplitModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    myLot: function () {
                        return Lot.get({id: $scope.gridApi.selection.getSelectedRows()[0].id}).$promise;
                    }
                }
            });
            modalInstance.result.then(function () {
                refresh();
            });
        }
    }
})();
